module.exports = __webpack_public_path__ + "static/img/cd4511be-1.41e452f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/cd4511be-1.svg
// module id = srjj
// module chunks = 0